import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Page_settings } from "@/config/page_settings";
import fonts from "@/design/typography";
import { rootStore } from "@/mobx/store";
import ConfirmModal from "@/components/common/ConfirmModal";
import RowHeaderTable from "@/components/table/RowHeaderTable";
import Button from "@/components/button";
import colors from "@/design/colors";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { useWindowSize } from "@/hooks/useWindowSize";
import { deviceWidth } from "@/design/defaultTheme";

const BasicInfoTab = () => {

  /* **********************************
   * GLOBAL STATE
   * 전역 상태 및 전역 변수
   ********************************** */
  const context: any = useContext(Page_settings);
  const token = rootStore.getMe?.accessToken;
  const navigate = useNavigate();
  const { width } = useWindowSize();
  const isMobile = width < deviceWidth.mobile;
  const id = parseInt(useParams().id);

  /* **********************************
   * LOCAL STATE
   * 컴포넌트 내부에서 사용하는 상태
   ********************************** */
    const [confirmType, setConfirmType] = useState<"delete" | null>(null); // 삭제 모달
/* **********************************
   * Table
   * 테이블 데이터
   ********************************** */
  // 가맹점 정보 더미 데이터
  const [detailData, setDetailData] = useState(
    [
      //{ key: "NO", label: "NO.", value: "15" },
      { key: "platformName", label: "대표플랫폼", value: "" },
      { key: "storeCode", label: "가맹점코드", value: "" },
      { key: "catId", label: "온라인 CAT ID", value: "" },
      { key: "storeName", label: "가맹점명", value: "" },
      { key: "bizRegNum", label: "사업자번호", value: "" },

      { key: "taxTypeName", label: "부가세", value: "" },
      { key: "taxRate", label: "부과세비율(%)", value: "" },
      { key: "serviceChargeYnName", label: "봉사료", value: "" },
      { key: "serviceChargeRate", label: "봉사료율(%)", value: "" },

      { key: "ceoName", label: "대표자명", value: "" },
      { key: "businessTypeCode", label: "업태코드", value: "" },
      { key: "telNum", label: "전화번호", value: "" },
      { key: "emailAddr", label: "이메일", value: "" },
      { key: "naverMerchantid", label: "네이버가맹점ID", value: "" },
    ]
    );


  /* **********************************
   * EFFECTS
   * 컴포넌트 상태 변경 처리
   ********************************** */
  // 토큰 유무 확인
  useEffect(() => {
    if (!token) return;
  }, [token]);
    
  useEffect(() => {
    if (!Number.isFinite(id)) return;
  
    context.post(
      `/office/getStoreDetail`,
      {
        storeInfoId: id,
      },
      (response) => {
        console.log(response);
  
        const updated = detailData.map((item) => {
          if (item.key === 'platformName') {
            return { ...item, value: response.platformName };
          } else if (item.key === 'catId') {
            return { ...item, value: response.catId };
          } else if (item.key === 'storeName') {
            return { ...item, value: response.storeName };
          }  else if (item.key === 'bizRegNum') {
            return { ...item, value: response.bizRegNum };
          } else if (item.key === 'ceoName') {
            return { ...item, value: response.ceoName };
          } else if (item.key === 'businessTypeCode') {
            return { ...item, value: response.businessTypeCode };
          } else if (item.key === 'telNum') {
            return { ...item, value: response.telNum };
          } else if (item.key === 'emailAddr') {
            return { ...item, value: response.emailAddr };
          } else if (item.key === 'storeCode') {
            return { ...item, value: response.storeCode };
          } else if (item.key === 'taxTypeName') {
            return { ...item, value: response.taxTypeName };
          } else if (item.key === 'taxRate') {
            return { ...item, value: response.taxRate };
          } else if (item.key === 'serviceChargeYnName') {
            return { ...item, value: response.serviceChargeYnName };
          } else if (item.key === 'serviceChargeRate') {
            return { ...item, value: response.serviceChargeRate };
          } else if (item.key === 'naverMerchantid') {
            return { ...item, value: response.naverMerchantid };
          } 
          
          return item; // 나머지는 그대로
        });

        setDetailData(updated);      
      }
    );
      
  }, [id]);

  /* **********************************
   * Handler
   * 이벤트 핸들러
   ********************************** */
  // 삭제 확인 모달
  const handleConfirm = async () => {
    if (confirmType === "delete") {
      try {
        console.log("삭제");
        //삭제요청
        context.post(
          `/office/deleteStoreInfo`,
          {
            storeInfoId: id
          },
          (response) => {
            console.log(response);
            if(response.RESULT_CODE === "0000"){  //
              alert("정상적으로 처리되었습니다.")
              setConfirmType(null);
              navigate("/payment/franchise-list");
            }else{ //실패
              alert(response.RESULT_MSG);
              setConfirmType(null);
            }
          }
        );
        setConfirmType(null);
      } catch (error) {
        console.error("Failed to delete platform:", error);
        alert("삭제 처리 중 오류가 발생했습니다.");
        setConfirmType(null);
      }
    }
  };

    return (
        <div style={{display: "flex", flex:1,flexDirection: "column", width: "100%"}}>
{/* 가맹점 정보 */}
    <section
      style={{
        marginBottom: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <SubTitle>가맹점 정보</SubTitle>
      <div style={{ display: "flex", gap: "10px" }}>
        <Button
          text="수정"
          size="small"
          width="60px"
          height="32px"
          buttonColor={colors.blue600}
          textColor={colors.white}
          customFontSize={isMobile ? "11px" : "13px"}
          style={{ padding: "0 10px" }}
          type="button"
          onClick={() => {
            navigate(`/payment/franchise-edit/${id}`);
          }}
        />
        <Button
          text="삭제"
          size="small"
          width="60px"
          height="32px"
          buttonColor={colors.warning}
          textColor={colors.warning50}
          customFontSize={isMobile ? "11px" : "13px"}
          style={{ padding: "0 10px" }}
          onClick={() => {
            console.log("삭제:", id);
            setConfirmType("delete");
          }}
        />
      </div>
    </section>
    <section style={{display: "flex",}}>
        <RowHeaderTable data={detailData} />
    </section>
    {/* 삭제 확인 모달 */}
    {!!confirmType && (
      <ConfirmModal
        width="fit-content"
        isOpen={!!confirmType}
        onClose={() => setConfirmType(null)}
        message="선택한 가맹점을 삭제하시겠습니까?"
        buttons={[
          {
            text: "취소",
            onClick: () => setConfirmType(null),
            buttonColor: colors.gray200,
            textColor: colors.gray700,
          },
          {
            text: "삭제",
            onClick: handleConfirm,
            buttonColor: colors.warning,
            textColor: colors.gray50,
          },
        ]}
      />
    )}
    </div>
  );
}

export default BasicInfoTab;

const SubTitle = styled.span`
  font-family: ${fonts.body2SemiBold.fontFamily};
  font-size: ${fonts.body2SemiBold.fontSize};
  line-height: ${fonts.body2SemiBold.lineHeight};
  color: ${colors.gray900};

  ${({ theme }) => theme.device.mobile} {
    font-size: 0.8rem;
  }
`;